import { useSelector } from 'react-redux';
import { DefaultRootState } from '../persistState';
import { createSelector } from '@reduxjs/toolkit';

export const menuSelector = () => {
	const menu = useSelector((state: DefaultRootState) => state.UI);
	return menu;
};
export const selectMenu = createSelector(menuSelector);

export const selectSecondaryMenu = () => {
	const secondaryMenu = useSelector(
		(state: DefaultRootState) => state.UI.secondaryMenuOpen
	);
	return secondaryMenu;
};

export const selectSecondaryMenuContext = () => {
	const secondaryMenuContext = useSelector(
		(state: DefaultRootState) => state.UI.secondaryMenuContext
	);
	return secondaryMenuContext;
};

export const menuTypeSelector = () => {
	const secondaryMenuType = useSelector(
		(state: DefaultRootState) => state.navigation.menuType
	);
	return secondaryMenuType;
};

export const selectMenuType = () => createSelector(menuTypeSelector);

export const selectPage = () => {
	const selectPage = useSelector(
		(state: DefaultRootState) => state.navigation.page
	);
	return selectPage;
};

// 1. Create a basic "input selector" to get the UI slice of the state.
const selectUiSlice = (state) => state.UI;

// 2. Create a memoized selector using createSelector.
// It takes the input selector(s) and a function that transforms the result.
export const selectMenuOpen = createSelector(
  [selectUiSlice], // An array of input selectors
  (ui) => ui.menuOpen // The "result function"
);